import { encode } from './index';

export function caseOpenIc(options) {
  return key => (result, value) => {
    if (value === null || value === undefined || value?.length === 0) {
      return result;
    }

    let res;
    if (result.length === 0) {
      res = [
        [
          encode(key, options),
          '=',
          encodeURI('['),
          encode(value, options)
        ].join('')
      ];
    } else {
      result = result[0].substring(0, result[0].length - 3);
      res = [
        [result, encode(value, options)].join(options.arrayFormatSeparator)
      ];
    }
    res = res[0].concat(encodeURI(']'));
    return [res];
  };
}
